import { useNavigate } from 'react-router-dom';
import style from './comment-list-item.module.scss';
import { TArticle, TComment, TUser } from '../../../models/common';
import helperService from '../../../services/helper.service';
import ProfilePhoto from '../../molecules/profile-photo/profile-photo';

interface CommentListItemProps {
  comment: TComment;
}

function CommentListItem({ comment }: CommentListItemProps) {
  const navigate = useNavigate();
  const newDate = new Date(comment.created_at as string);

  const handleNavigate = () => {
    navigate(helperService.getNavigateLink(comment.reply_to as TArticle));
  };

  return (
    <div onClick={handleNavigate} key={comment._id} className={style['comment-list-item']}>
      <div className={style['user-info']}>
        <ProfilePhoto user={comment.owner as TUser} width="40px" height="40px" />
        <div className={style['comment-info']}>
          <b>{(comment.owner as TUser)?.username}</b> commented on{' '}
          <b>{(comment.reply_to as TArticle)?.title}</b>
          <div className={style['created-date']}>
            {helperService.formatDateToMonthDayYear(newDate)}
          </div>
        </div>
      </div>

      <div className={style['comment-content']}>{comment.message}</div>
    </div>
  );
}

export default CommentListItem;
